<template>
	<div id="contenedor-principal-Pagos" style="position:relative;">
		<div id="contenedor-encabezados-Pagos" class="text-left">
		</div>
		<div class="row">
		<div id="contenedor-principal-Reportes" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4"><!--IZQUIERDA-->
			<div class="area_verde">
			<div id="select-reporte-caja" class="form-group">
			<h1>Reportes</h1>
			<br>
			<h4>Creación de Reportes de Pagos</h4>
			<br>
				<h4>Tipo de Reporte</h4>
				<select v-model="TipoReporte" class="form-control" @change="limpiar">
					<option value="0">Seleccione tipo de reporte</option>
					<option value="1">Pagos en Caja</option>
					<option value="2">Por Tipo de Rubro</option>
					<option value="3">Por Juzgado</option>
				</select>
			<template> 
				<!-- <transition-group name="fade"> -->

					<div v-show="TipoReporte == 2" class="form-group" :key="rubroKey">
						<div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="form-group">
							<div v-if="catalogo.catalogoId == enumeraciones.catalogos.Rubros" class="form-group" id="Rubros_div">
								<br>
          						<h6>Concepto</h6>
          						<C006TiposRubro 
            						:class="[parametros_Rubro.esInformativo ? 'catalogoInformativo' : '']" 
            						@valorParaElPadre="cambioDeRubroEvento" 
            						@valorParaElPadrePrimerElemento="cambioDeRubro" 
            						:prefijo="catalogo.etiquetaDeHtml" 
            						:tipo="catalogo.tipoDeSelect" 
            						:idDelInput="catalogo.idDelInput" 
            						:parametros="parametros_Rubro.parametros" 
            						:valorDefinido="parametros_Rubro.rubroId" 
            						:key="parametros_Rubro.key"
            						ref="tiposRubro">
          						</C006TiposRubro>
        					</div> 
        				</div>
					</div>

					<div v-show="TipoReporte == 3" class="form-group" :key="areaKey">
						<div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="form-group">
							<div v-if="catalogo.catalogoId == enumeraciones.catalogos.Juzgados" id="Juzgados_div">
								<br>
          						<h6>Juzgado</h6>
          						<C001Area 
            						:class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" 
            						@valorParaElPadre="cambioDeAreaEvento" 
            						@valorParaElPadrePrimerElemento="cambioDeArea"
            						:prefijo="catalogo.etiquetaDeHtml" 
            						:tipo="catalogo.tipoDeSelect"  
            						:idDelInput="catalogo.idDelInput" 
            						:parametros="parametros_Area.parametros" 
            						:valorDefinido="parametros_Area.areaId" 
            						:key="parametros_Area.key"
            						ref="areas">
          						</C001Area>
        					</div>
        				</div>
					</div>
				<!-- </transition-group> -->
			</template>
				<br>
					<div>
						<div class="form-group" id="rangofechas_div" >
          					<h4 v-if="!rangofechas">Por Historial</h4>
          					<h4 v-else>Rango de Fechas de Pagos</h4>
    					</div>
						<input type="checkbox" id="rangofechas" v-model="rangofechas" @change="rangoDeFechas($event)">
    					<div v-if="rangofechas">
						<div class="form-group" id="fechaInicial_div">
							<label>Fecha Inicial:</label>
							<input class="form-control" type="date" v-model="Busqueda.fechaInicial" :max="Busqueda.fechaFinal">
						</div>
						<div class="form-group" id="fechaFinal_div">
							<label>Fecha Final:</label>
							<input class="form-control" type="date" v-model="Busqueda.fechaFinal" :max="fechaMaxima">
						</div>
						</div>
					</div>
				<br>
				<div>
          				<h6>Tipo de documento</h6>
          					<C004TiposDocumento 
          						:class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" 
          						v-on:valorParaElPadre="cambioDeTipoDeDocumento" 
          						:prefijo="enumeraciones.etiquetasDeHTML.Select" 
          						:tipo="enumeraciones.tiposDeSelect.Seleccione" 
          						:idDelInput="enumeraciones.idDelInput" 
          						:parametros="parametros_TipoDocumento.parametros" 
          						:valorDefinido="parametros_TipoDocumento.tipoDocumentoId" 
          						:key="parametros_TipoDocumento.key">
          					</C004TiposDocumento>

						<div class="form-group"  id="Consecutivo_div">
          					<h6>Consecutivo</h6>
          					<input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" id="Consecutivo" :idDelInput="enumeraciones.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" autocomplete="off"/>
        				</div>
        				<div v-if="(consecutivo && consecutivo.length == 9)">
          					<h6>Número romano</h6>
          					<input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="Numero Romano" @input="(val) => (numeroRomano = numeroRomano.toUpperCase())" @keypress="esRomano($event)"/>
        				</div>


					<div class="form-group" id="nombre_div">     
          				<h6>Nombre(s)</h6>
          				<input class="form-control" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre" @input="(val) => (nombre = nombre.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    				</div>
    				<div class="form-group" id="apellido_paterno_div">
         				 <h6>Apellido Paterno</h6>
          				<input class="form-control" type="text" placeholder="Ingrese el apellido paterno" v-model="apellido_paterno" id="apellido_paterno" @input="(val) => (apellido_paterno = apellido_paterno.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    				</div>
    				<div class="form-group" id="apellido_materno_div">
          				<h6>Apellido Materno</h6>
          				<input class="form-control" type="text" placeholder="Ingrese el apellido materno" v-model="apellido_materno" id="apellido_materno" @input="(val) => (apellido_materno = apellido_materno.toUpperCase())" @keypress="esLetra($event)" @keyup.enter='ejecutaLaFuncion()' autocomplete="off" @paste.prevent/>
    				</div>
    			</div>
			</div> 
		</div>
			<!--Descomentar en caso de necesitar mas tipos de reporte-->
		<!-- <template> -->
			<!-- por historial -->
		<!-- Por rubro -->
		<div class="area_verde">

						<div v-if="TipoReporte > 0" id="BotonBusqueda_div" class="text-left table">
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="seleccionarGrafica(1, $event); "><i class="fas fa-chart-pie fa-lg"></i>&nbsp;Reporte acumulado {{tipoConcepto}}</button><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="seleccionarGrafica(2, $event)"><i class="fas fa-chart-bar fa-lg"></i>&nbsp;Reporte recaudado {{tipoConcepto}}</button><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="seleccionarGrafica(3, $event)"><i class="fas fa-chart-area fa-lg"></i>&nbsp;Reporte de pagos en caja por día</button><br><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="buscarPagosRangoFechas(true); bloquearBoton($event)"><i class="fas fa-file-alt fa-lg"></i>&nbsp;Crear Reporte General</button><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="descargarExcel(true); bloquearBoton($event)"><i class="fas fa-file-excel fa-lg"></i>&nbsp;Descargar Excel</button><br><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="buscarPagosRangoFechas(false); bloquearBoton($event)"><i class="fas fa-file-alt fa-lg"></i>&nbsp;Reporte Folios Inhabilitados</button><br><br>
							<button class="btn-bsq btn-buscar btn col-12 form-group" @click="buscarDevoluciones(); bloquearBoton($event);"><i class="fas fa-file-import fa-lg"></i>&nbsp;Reporte Pagos Devueltos</button><br><br>
						</div>
					</div>
			</div><!--IZQUIERDA-->
			<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8 ">
			<div class="area_verde"><!--DERECHA-->
				<div id="grafica" :key="graficaKey" v-if="mostrarGrafica">
					<Pastel v-if="grafica == 1 && datosGrafica && !abrirTabla" 
					:chartData="{
      					labels: etiquetas,
      					datasets: [
        					{
          					backgroundColor: colores,
          					borderWidth: 0, //dejar tal vez
          					data: datosGrafica,
          					rubros: this.rubrosId,
          					areas: this.areasId,
          					areaId: this.parametros_Area.areaId,
          					rubroId: this.parametros_Rubro.rubroId,
        					}
      					]
    				}"
    				:color="graficaPDF"
    				:titulo="nombreBoton"
					ref="graficaPastel"
					@crearTabla="crearTabla">
					</Pastel>
					
					<Barras v-if="grafica == 2 && datosGrafica && !abrirTabla"
					:chartData="{
      					labels: etiquetas,

      					datasets: [
        					{
        					label: 'Cantidad por rubro',
          					backgroundColor: '#007bff',
          					barThickness: 'flex',
          					offset: true,
          					data: datosGrafica,
          					rubros: this.rubrosId,
          					areas: this.areasId,
          					areaId: this.parametros_Area.areaId,
          					rubroId: this.parametros_Rubro.rubroId,
        					}
      					]
    				}"
    				:color="graficaPDF"
    				:titulo="nombreBoton"
					ref="graficaBarras"
					@crearTabla="crearTabla">
					</Barras>
				
					<Linea v-if="grafica == 3 && datosGrafica && !abrirTabla"
					:chartData="{
      					labels: labelFechas,

      					datasets: [
        					{
        					label: 'Cantidad Recibida',
          					//backgroundColor: '#007bff',
          					borderColor: '#007bff',
          					pointRadius: 4,
          					pointBackgroundColor: '#007bff',
          					pointHoverBackgroundColor: '#0005ff',
          					pointHoverBorderColor: '#0005ff',
          					data: datosGrafica,
          					rubros: this.rubrosId,
          					areas: this.areasId,
          					areaId: this.parametros_Area.areaId,
          					rubroId: this.parametros_Rubro.rubroId,
        					}
      					]
    				}"
    				:color="graficaPDF"
    				:titulo="nombreBoton"
					ref="graficaLinea"
					@crearTabla="crearTabla">
					</Linea>

					<TablaDeResultados
						v-if="Pagos && abrirTabla"
						:Pagos="Pagos"
						:Regresar="botonRegresar"
						:BotonRegresar="BotonRegresar"
						>
					</TablaDeResultados>

					<div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="form-group" style="display: none">
						<div v-if="catalogo.catalogoId == enumeraciones.catalogos.Rubros" class="form-group" >
          					<C006TiposRubro 
            					:prefijo="catalogo.etiquetaDeHtml" 
            					:tipo="catalogo.tipoDeSelect" 
            					:idDelInput="catalogo.idDelInput" 
            					:parametros="parametros_Rubro.parametros" 
            					ref="tiposRubro">
          					</C006TiposRubro>
        				</div> 
        			</div>
				</div>

			</div>
			</div>
		</div>
			<div v-if="TipoReporte > 0 && this.buscar" id="ReportePDF" style="display: none;">
				<Reporte
				:grafica="guardarGrafica"
				ref="reporteFecha"
				:TipoReporte="TipoReporte">
				</Reporte>
			</div>
		</div>
</template>

<script>
	import Vue from 'vue'
	import enumeraciones from '@/../static/js/enumeraciones'
	import api from '@/../static/js/api'
	import comun from '@/../static/js/comun'
	import axios from 'axios'
  	import catalogos from '@/../static/js/catalogos'
  	import TablaDeResultados from '@/components/SIVAC/Comun/TablaDeResultados.vue'

	import Reporte from '@/components/SIVAC/Reportes/ReporteArchivo.vue'
	import Pastel from './Graficas/Pastel.vue'
	import Barras from './Graficas/Barras.vue'
	import Linea from './Graficas/Linea.vue'


	export default{

		beforeMount(){
    		this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          	this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;

        	if(this.elementosAConservar.tiposDocumento && this.elementosAConservar.tiposDocumento.length > 0){
          		this.parametros_TipoDocumento.parametros.elementosAConservar = this.elementosAConservar.tiposDocumento;
          		this.parametros_TipoDocumento.key = "elementosAConservar_" + this.elementosAConservar.tiposDocumento.length;     
        	}
    	},
		components:{
			Reporte,
      		TablaDeResultados,
			Pastel, Barras, Linea,
			C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      		C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
			C001Area: catalogos.PJ.C001Area
		},
		data(){
			return{
				enumeraciones,
				Reporte: {},
				Busqueda: {
					fechaInicial: moment().startOf('week').add(-2, 'days').format('YYYY-MM-DD'), //del viernes pasado al jueves de esta semana
					fechaFinal: moment().endOf('week').add(-2, 'days').format('YYYY-MM-DD')
				},
				TipoReporte: 0,
				parametros_Rubro: {
          			key: "",
          			rubroId: -1,
          			parametros: {
            			ConOrdenPorNombre: true
          			},
          			esInformativo: false
        		},
        		parametros_Area: {
          			key: "",
          			areaId: -1,
          			parametros: {},
          			esInformativo: false
        		},
        		parametros_TipoDocumento: {
          			key: "",
          			tipoDocumentoId: -1,
          			parametros: {},
          			esInformativo: false
        		}, 
        		parametros_Consecutivo: {
          			key: "",
          			parametros: {},
          			esInformativo: false
        		},       
        		parametros_Materia: {
          			key: "",
          			materiaId: -1,
          			parametros: {},
          			esInformativo: false
        		},		
        		parametros_Area: {
          			key: "",
          			areaId: -1,
          			parametros: {},
          			esInformativo: false
        		},

        		catalogos : [
        		{	catalogoId: enumeraciones.catalogos.Rubros, 
        			etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, 
        			tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, 
        			idDelInput: 'filtroDeBusqueda_Rubro' 
        		},
        		{
        			catalogoId: enumeraciones.catalogos.Juzgados, 
        			etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, 
        			tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, 
        			idDelInput: 'filtroDeBusqueda_Area' 
        		}],
        		elementosAConservar: {
        			tiposDocumento: [1, 23, 26],
           			areas: [95, 54, 53, 48, 52, 51, 12],
           			partidosJudiciales: [1],
           			materias: [6, 9]
        		},
				buscar: false,
				grafica : 0,
				datosGrafica : [],
				tiposRubro: [],
				nombresArea: [],
				rubrosEncontrados: [],
				rubrosId: [],
				areasId: [],
				colores: [],
				labelFechas: [],
				etiquetas: [],
				Pagos : null,
				abrirTabla : false,
				areaKey: 0,
				rubroKey: 1,
				graficaKey: 2,
				cargado: true,
				graficaPDF: true,
				mostrarGrafica: false,
				nombreBoton : '',
        		fechaMaxima: moment().endOf('week').add(-1, 'days').format('YYYY-MM-DD'),
        		tipoConcepto: '',
        		nombre: null,
        		apellido_paterno: null,
        		apellido_materno: null,
        		consecutivo: null,
        		numeroRomano: null,
        		rangofechas: true
			}
		},
		methods: {
			checarPagos: function(activo){

				const parametros = {
					fechaInicio : this.Busqueda.fechaInicial,
					fechaFin : this.Busqueda.fechaFinal,
					rubroId : this.parametros_Rubro.rubroId,
					areaId : this.parametros_Area.areaId,
					activo : activo,
					TipoDeDocumentoId : this.parametros_TipoDocumento.tipoDocumentoId,
					Consecutivo : this.consecutivo ? this.consecutivo : null,
					NumeroRomano : this.numeroRomano ? this.numeroRomano : null,
					Nombre : this.nombre ? this.nombre : null,
					ApellidoPaterno : this.apellido_paterno ? this.apellido_paterno : null,
					ApellidoMaterno : this.apellido_materno ? this.apellido_materno : null
				}

				if(this.parametros_Rubro.rubroId < 0 && this.TipoReporte == 2){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese Un Concepto", null, null);
				}
				else if(this.parametros_Area.areaId < 0 && this.TipoReporte == 3){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese Un Area", null, null);
				}
				else{
					this.buscar = true;
				}
				if(((!this.Busqueda.fechaInicial || this.Busqueda.fechaInicial <=0) && this.Busqueda.fechaFinal != null) || 
					(this.Busqueda.fechaInicial != null && (!this.Busqueda.fechaFinal || this.Busqueda.fechaFinal <=0))){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese una fecha válida", null, null);
				}
				return parametros
			},

			buscarPagosRangoFechas: function(activo){
				const parametros = this.checarPagos(activo)

				if(!activo) this.mostrarGrafica = false; //no hace falta grafico para inactivos

				this.actualizarGrafica();
				if(this.buscar){
					setTimeout(()=>{//sin el timeout da error
						this.$refs['reporteFecha'].imprimirReporte(parametros);

					}, 1)
				}
			},
			buscarDevoluciones: function(){
				const parametros = {
					fechaInicio : this.Busqueda.fechaInicial,
					fechaFin : this.Busqueda.fechaFinal,
					rubroId : this.parametros_Rubro.rubroId,
					areaId : this.parametros_Area.areaId,
					TipoDeDocumentoId : this.parametros_TipoDocumento.tipoDocumentoId,
					Consecutivo : this.consecutivo ? this.consecutivo : null,
					NumeroRomano : this.numeroRomano ? this.numeroRomano : null,
					Nombre : this.nombre ? this.nombre : null,
					ApellidoPaterno : this.apellido_paterno ? this.apellido_paterno : null,
					ApellidoMaterno : this.apellido_materno ? this.apellido_materno : null
				}

				if(this.parametros_Rubro.rubroId < 0 && this.TipoReporte == 2){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese Un Concepto", null, null);
				}
				else if(this.parametros_Area.areaId < 0 && this.TipoReporte == 3){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese Un Area", null, null);
				}
				else{
					this.buscar = true;
				}
				if(((!this.Busqueda.fechaInicial || this.Busqueda.fechaInicial <=0) && this.Busqueda.fechaFinal != null) || 
					(this.Busqueda.fechaInicial != null && (!this.Busqueda.fechaFinal || this.Busqueda.fechaFinal <=0))){
					this.buscar = false;
					comun.mensajeDeAlerta("Ingrese una fecha válida", null, null);
				}

				this.mostrarGrafica = false; //no hace falta grafico para devoluciones

				this.actualizarGrafica();
				if(this.buscar){
					setTimeout(()=>{//sin el timeout da error
						this.$refs['reporteFecha'].imprimirReporteDevoluciones(parametros);

					}, 1)
				}
			},
			actualizarGrafica: function(){
				this.graficaKey += 1;
				this.graficaPDF = !this.graficaPDF;
			},

			descargarExcel: function(activo){
				const parametros = this.checarPagos(activo)
				if(this.buscar){
					setTimeout(()=>{//sin el timeout da error
						this.$refs['reporteFecha'].crearExcel(parametros);
					}, 1)
				}
			},
			
			cambioDeRubroEvento(datos){
        		this.cambioDeRubro(parseInt(datos.target.value));
      		},

      		cambioDeRubro(id){
        		this.parametros_Rubro.rubroId = id;
				this.mostrarGrafica = false;
      		}, 
      		cambioDeTipoDeDocumento(datos) {
        		this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
        		this.numeroExtra = null;
        		this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
      		}, 

      		cambioDeAreaEvento: function(datos) {
        		this.cambioDeArea(parseInt(datos.target.value));
      		},

      		cambioDeArea(id){
        		this.parametros_Area.areaId = id;
				this.mostrarGrafica = false;
      		},
      		limpiar: function(){
      			this.parametros_Area.areaId = -1;
      			this.parametros_Rubro.rubroId = -1;
      			this.areaKey += 1;
      			this.rubroKey += 1;
				this.buscar = false;
				this.mostrarGrafica = false;
      			if(this.TipoReporte == 1 ||this.TipoReporte == 2) this.tipoConcepto = 'por concepto'
      			if(this.TipoReporte == 3) this.tipoConcepto = 'por juzgado'
      		},

      		crearTabla(abrir, buscar){
      			this.abrirTabla = abrir;
      			this.Pagos = null;
      			const parametros = {
					fechaInicio : buscar.fecha == null ? this.Busqueda.fechaInicial : buscar.fecha,
					fechaFin : buscar.fecha == null ? this.Busqueda.fechaFinal : buscar.fecha,
					rubroId : buscar.rubroId,
					areaId : buscar.areaId
				}

      			const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

      			return axios.post(api.conexion + api.SIVAC.sistema.reportes.pagos.ReporteCaja, parametros, headerPeticion)
							.then( respuesta => {
								comun.SeEstaCargandoInformacion(false);
								if (respuesta.data.SiHayError) {
									comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
									throw new Error("No hay");
								}
								else{  
									this.Pagos = respuesta.data.Pagos
									this.BotonRegresar = respuesta.data.Pagos
								}
							}).catch(error => {
								return error;
							})
      		},
      		
      		seleccionarGrafica(grafica, e){

      			this.nombreBoton = this.getNombreBoton(e);

				this.datosGrafica = [];
				this.rubrosEncontrados = [];

				this.rubrosId = [];
				this.tiposRubro = [];

				this.colores = [];
				this.labelFechas = [];
				this.abrirTabla = false;

				this.nombresArea = [];
				this.areasId = [];

				this.etiquetas = [];

      			this.grafica = grafica;
      			this.mostrarGrafica = true;

      			const parametros = {
					fechaInicio : this.Busqueda.fechaInicial,
					fechaFin : this.Busqueda.fechaFinal,
					rubroId : this.parametros_Rubro.rubroId,
					areaId : this.parametros_Area.areaId
				}

				if(this.cargado == true){
					this.cargado = false;

					if(parametros.rubroId < 0 && parametros.areaId < 0 && this.TipoReporte > 1){

						this.cargado = true
					
						switch(parseInt(this.TipoReporte)){
							case 2:
								comun.mensajeDeAlerta("Ingrese Un Concepto", null, null);
								break;
							case 3:
								comun.mensajeDeAlerta("Ingrese Un Area", null, null);
								break;
							default:
								break;
						}
					}
					else{

						const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 
						return axios.post(api.conexion + api.SIVAC.sistema.reportes.pagos.ReporteCaja, parametros, headerPeticion)
							.then( respuesta => {
								
								comun.SeEstaCargandoInformacion(false);
								if (respuesta.data.SiHayError) {
									this.cargado = true
									comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
									throw new Error("No hay");
								}
								else{  
									this.Pagos = respuesta.data.Pagos
									
									/////////////////////////////////////tipo de grafica

									switch (this.grafica) {
										case 1:///////////pastel para porcentajes
											this.pastelPagos(parametros.rubroId);
												break;
										case 2://///////////////barras para dinero
											this.barrasPagos(parametros.rubroId);
												break;
										case 3:////////////linea para diario
											this.lineaPagos(parametros.rubroId);
												break;
										default:
											break;
									}
									this.cargado = true
									return this.datosGrafica       
								}
							}).catch(error => {
								return error;
							})
					}

				}

      		},

			pastelPagos: function(rubroId){
				this.getAreas()
				this.getRubros()

				if(rubroId > 0){
					this.Pagos.forEach((pago, index)=>{
						
							this.rubrosEncontrados.push(pago.Expediente.Area.AreaId)
						
					})

					this.areasId = this.creaEtiquetas(this.areasId, this.nombresArea);
				}

				else{
					this.Pagos.forEach((pago, index) =>{
						
							this.rubrosEncontrados.push(pago.RubroDBPJ.TipoRubroId)
						
					});

					this.rubrosId = this.creaEtiquetas(this.rubrosId, this.tiposRubro);
				}

			},
			barrasPagos: function(rubroId){
				this.getAreas()
				this.getRubros()

				var etiquetas = [];
				var quitarTiposRubro = [];

				if(rubroId > 0){

					this.areasId.forEach((AreaId, index) =>{
						var total = 0;
						this.Pagos.forEach((pago, index) =>{
							
								if(AreaId == pago.Expediente.Area.AreaId) 
									total += pago.Monto
							
						});
						this.datosGrafica.push(total)
						if(total <= 0)
							quitarTiposRubro.push(AreaId)
					})
					this.areasId = this.areasId.filter(quitar => !quitarTiposRubro.includes(quitar))

					etiquetas = this.nombresArea;

				}
				else{
					this.rubrosId.forEach((RubroId, index) =>{
						var total = 0;
						this.Pagos.forEach((pago, index) =>{
							
								if(RubroId == pago.RubroDBPJ.TipoRubroId) 
									total += pago.Monto
							
						});
						this.datosGrafica.push(total)
						if(total <= 0)
							quitarTiposRubro.push(RubroId)
					})
					this.rubrosId = this.rubrosId.filter(quitar => !quitarTiposRubro.includes(quitar))
										
					etiquetas = this.tiposRubro;
				}

				etiquetas.forEach((tipoRubro, index) => {
						etiquetas[index] = etiquetas[index].concat(' $', this.datosGrafica[index].toLocaleString('en-US', {minimumFractionDigits: 2}));
				});

				this.etiquetas = etiquetas;

				this.etiquetas = this.etiquetas.filter(etiqueta => !etiqueta.includes('$0'))
				this.datosGrafica = this.datosGrafica.filter(dato => dato > 0)
			},
			lineaPagos: function(rubroId){
				this.getAreas()
				this.getRubros()
				var fechaInicial = new Date(this.Busqueda.fechaInicial)
				var fechaFinal = new Date(this.Busqueda.fechaFinal)
				fechaInicial.setDate(fechaInicial.getDate() + 1)
				fechaFinal.setDate(fechaFinal.getDate() + 1)

				while(fechaInicial <= fechaFinal){
					var total = 0
					this.Pagos.forEach((pago, index) => {
						
							if(this.formatoFecha(fechaInicial) == this.formatoFecha(pago.FechaDePago))
								total += pago.Monto
						
					});
					this.datosGrafica.push(total)
					this.labelFechas.push(this.formatoFecha(fechaInicial))
												
					fechaInicial.setDate(fechaInicial.getDate() + 1)
				}
				
			},
			getRubros: function(){
				if(this.$refs['tiposRubro'] && this.parametros_Rubro.rubroId <= 0){
					this.$refs['tiposRubro'][0].tiposRubros.forEach((Rubro) =>{
						this.tiposRubro.push(Rubro.Nombre)
						this.rubrosId.push(Rubro.TipoRubroId)
					});
				}
			},
			getAreas: function(){
				if(this.$refs['areas'] && this.parametros_Area.areaId <= 0){
					this.$refs['areas'][0].Areas.forEach((Area) =>{
						this.nombresArea.push(Area.Abreviatura)
						this.areasId.push(Area.AreaId)
					});

				}
			},
			creaEtiquetas: function(rubros, etiquetas){

				var total = 0
				var quitarTiposRubro = [];

				rubros.forEach((RubroId, index) => {
					var contar = 0;
					for(var i = 0; i < this.rubrosEncontrados.length; ++i){
						if(this.rubrosEncontrados[i] == RubroId)
							contar++
					}
					total += contar
					if(contar <= 0)
						quitarTiposRubro.push(RubroId)

					this.datosGrafica.push(contar);
					this.colores.push(this.getRandomColor());
					etiquetas[index] = etiquetas[index].concat(': ', contar, ' (');					
				});

				etiquetas.forEach((tipoRubro, index) => {
					etiquetas[index] = etiquetas[index] + this.porcentaje(this.datosGrafica[index], total) + '%)';
				});

				this.etiquetas = etiquetas;

				rubros = rubros.filter(quitar => !quitarTiposRubro.includes(quitar))

				this.etiquetas = this.etiquetas.filter(etiqueta => !etiqueta.includes('(0%)'))
				this.datosGrafica = this.datosGrafica.filter(dato => dato > 0)
				return rubros
			},

			getRandomColor : function(){////colores random
				var color;
				var r = Math.floor(Math.random() * 255);
				var g = Math.floor(Math.random() * 255);
				var b = Math.floor(Math.random() * 255);
				color = "rgb("+r+" ,"+g+","+ b+")";
				return color; 
			},
			porcentaje: function(valor, total){
				return (valor > 0 && total > 0) ? ((100 * valor) / total).toFixed(2) : 0;
			},
			diasRangoFechas: function(fechaInicial, fechaFinal){
				return Math.abs((fechaInicial.getTime() - fechaFinal.getTime()) / (1000 * 60 * 60 *24))
			},
			formatoFecha: function(fecha){
				return new Date(fecha).toLocaleDateString('en-GB')
			},
			bloquearBoton: function(boton){
				var anterior = boton.target.value;

				boton.target.setAttribute('disabled', true);
				boton.target.value = '';

				setTimeout(function(){
					boton.target.value = anterior;
					boton.target.removeAttribute('disabled');
				}, 2000)
			},
			guardarGrafica: function(){
				var imagen = '';
				var img = '';
				
				if(document.getElementsByTagName('canvas').length > 0){
					imagen = document.getElementsByTagName('canvas');
					img = imagen[0].toDataURL();
				}
								
				return img;
			},
			getNombreBoton: function(e){
				return e.target.textContent;
			},

			botonRegresar:function()
             {
       
             this.abrirTabla= false;
      
             },
      		cambioDeConsecutivo(datos) { 
        		this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      		},
      		esRomano: function(datos){///// I
        		let valor = (datos.which);
        		if (valor !== 105 && valor !== 73) {
            		datos.preventDefault();
        		}
    		},
    		rangoDeFechas: function(datos){
    			if(datos.target.checked){
    				this.Busqueda.fechaInicial = moment().startOf('week').add(-2, 'days').format('YYYY-MM-DD'); //del viernes pasado al jueves de esta semana
					this.Busqueda.fechaFinal = moment().endOf('week').add(-2, 'days').format('YYYY-MM-DD');
          		}
          		else{
            		this.Busqueda.fechaInicial = null;
					this.Busqueda.fechaFinal = null;
          		}
    		} 

	    }

	}
</script>

<style>
.bloquearDiv{
	pointer-events: none;
}
.wrapDivBloqueado
{
	opacity: 0.7;
	cursor: not-allowed;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.btn-bsq{
	margin-bottom:4px; 
	white-space: normal;
}
.btn-buscar{
    background-color: var(--gris-pj);
  }
  .area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/ReporteCaja.vue